import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import NewsBox from '../../../../components/newsBox';

class FFHBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { ffhTopic, ffhTitle, ffhList, ffhBoxData },
        } = this.props;

        return (
            <div id="ffhNewsList" className={styles.ffh_box}>
                <Chip id="50082" type="struct" title="新闻原创栏标题" groupName="新闻原创栏" content={ffhTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75113"
                    type="recommend"
                    title="新闻原创栏头条"
                    groupName="新闻原创栏"
                    content={ffhTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75114"
                    type="recommend"
                    title="新闻原创栏新闻列表"
                    groupName="新闻原创栏"
                    content={ffhList}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75115"
                    type="recommend"
                    title="新闻原创栏新闻盒"
                    groupName="新闻原创栏"
                    content={ffhBoxData}
                    translate="handleNewsBoxData">
                    <NewsBox />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FFHBox);
